/**
 * @param {*} filePath
 * @param {*} fileUrl
 * @returns {ToothDO | null}
 */

export const getToothDOFromFilePath = async (filePath, fileUrl) => {
  const regex = /.*__(LOWER|UPPER)__TOOTH_(\d+).([^\s.]+)$/i;
  const match = filePath.match(regex);
  if (match) {
    const toothGumType = match[1];
    const toothIndex = parseInt(match[2], 10);
    const fileType = match[3];
    return {
      toothGumType,
      toothIndex,
      fileUrl,
      fileType,
      filePath,
    };
  }
  return null;
};
